import { Component, OnInit, ViewChild } from '@angular/core';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-game-tutorial',
  templateUrl: './game-tutorial.component.html',
  styleUrls: ['./game-tutorial.component.scss']
})
export class GameTutorialComponent implements OnInit {

  searched: any;
  search: any;
  ready: boolean = false;
  stages: number = 4;
  current: number = 1;
  @ViewChild('content') content;
  constructor(
    public route: RoutingService,
    public api: RestapiService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }

  switchSlide(target: any) {
    switch (target) {
      case 'next':
        (this.current + 1 <= 4) ? this.current++ : this.current = 1;
        break;
      case 'prev':
        (this.current - 1 > 0) ? this.current-- : this.current = 4;
        break;
      default:
        this.current = target;
    }
  }

  openSearch() {
    //console.log('selected')
    this.modalService.open(this.content, { windowClass: "modal-game" });
  }
}
